import * as React from 'react';
import {Dialog, DialogTitle, Grid, IconButton, Typography, WithStyles, withStyles} from '@material-ui/core';
import {EcoAgreementStatus, IEcoAgreement, IEcoSplit, IRespondEcoAgreement, IRespondEcoAgreementUpdate} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import ImgAvatar from "@components/common/avatar/ImgAvatar";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@components/common/button/Button";
import CardContent from "@material-ui/core/CardContent";
import TranslateNew from "@translate/TranslateNew";
import ChatButton from './ChatButton';
import { ChatType } from '@app-types/websocket/chat.types';
import { IFileDesc } from '@app-types/websocket/file.types';
import { Col, CustomDialogContent, DialogTop, Row } from './DialogComponens';
import {AgreementCardStyle as styles} from './AgreementCard.style';


const tn = TranslateNew.getInstance();



interface IState {
    seenCalled:boolean;
    zoomImage:IFileDesc|undefined;
}

interface IAgreementCardProps extends WithStyles<typeof styles> {
    agreement: IEcoAgreement;
    family: IFamilyMember[];
    userId: number;
    type: 'received' | 'sent';
    currency:string;
    respond: (response: IRespondEcoAgreement) => void;
    respondChange: (response: IRespondEcoAgreementUpdate) => void;
    edit: () => void;
    scrollTime:number;
    seen: (agreementId:number) => void;
    waitForAgreementChat:(id:number) => void;
}

class AgreementCard extends React.Component<IAgreementCardProps, IState> {

    private myRef: HTMLDivElement | null = null;

    constructor(props: IAgreementCardProps) {
        super(props);
    
        this.state = {
            seenCalled: false,
            zoomImage:undefined,
        };
    
    }

    public componentDidMount() {
        if (this.state.seenCalled === false 
          && this.props.agreement.seenBy.indexOf(this.props.userId) === -1) {
          if (this.isInViewport()) {
            this.setState({seenCalled:true});
            this.props.seen(this.props.agreement.id);
          }
        }
    }

    public componentDidUpdate(prevProps: Readonly<IAgreementCardProps>): void {
        if (this.state.seenCalled === false 
            && prevProps.scrollTime !== this.props.scrollTime
            && this.props.agreement.seenBy.indexOf(this.props.userId) === -1) 
        {
            if (this.isInViewport()) {
              this.setState({seenCalled:true});
              this.props.seen(this.props.agreement.id);
            }
          }
    }
    public render() {
        const {classes, agreement, type} = this.props;

        let fileUrl = ""; 
        const fileTitle:string = agreement.title;
        if (this.state.zoomImage !== undefined) {
          if (this.state.zoomImage.localUrl) {
            fileUrl = this.state.zoomImage.localUrl;
          } else if (this.state.zoomImage.url) {
            fileUrl = this.state.zoomImage.url;
          }
      
        }
    

        return (<>
            <div className={classes.card} ref={(el) => this.myRef = el}>
                <CardContent className={classes.cardContentListItem}>
                    <div className={classes.itemTopRow} onClick={() => this.props.edit()}>
                        {agreement.children.length > 0 && (
                            <div style={{display: 'flex', flexDirection: 'row', gap: '4px'}}>
                                {agreement.children.slice(0,2).map(
                                    (children, index) => {
                                        const account = this.props.family.find((member:IFamilyMember) => member.id === children);
                                        if (!account) return null;
                                        return this.getAvatar(account, 46, false, (index * -28));
                                    }
                                )}
                            </div>
                        )}
                        <div style={{flexDirection: 'column', display: 'flex', flex: 1, minWidth: 0}}>
                            <div style={{flexDirection: 'row', display: 'flex', justifyContent: 'flex-end'}}>
                                {(agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE &&
                                    (agreement.amount !== agreement.pendingChange.amount)) && (
                                    <div className={classes.heading2LineThrough}>
                                        {(agreement.amount && agreement.amount > 0)
                                            ? tn.formatNumber(agreement.amount, this.props.currency)
                                            : tn.lang.agreementNoPrice}
                                    </div>
                                )}
                            </div>
                            <div style={{
                                flexDirection: 'row',
                                display: 'flex',
                                justifyContent: 'space-between',
                                minWidth: 0,
                                gap: '4px',
                            }}>
                                <div className={classes.heading2} style={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                }}>
                                    {agreement.title}
                                </div>
                                <div style={{flexShrink: 0}}>
                                    {agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE
                                        ? <div className={classes.heading2}>
                                            {(agreement.pendingChange.amount && agreement.pendingChange.amount > 0)
                                                ? tn.formatNumber(agreement.pendingChange.amount, this.props.currency)
                                                : tn.lang.agreementNoPrice}
                                        </div>
                                        : <div className={classes.heading2}>
                                            {(agreement.amount && agreement.amount > 0)
                                                ? tn.formatNumber(agreement.amount, this.props.currency)
                                                : tn.lang.agreementNoPrice}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                                <div>
                                    <Typography
                                        color="textSecondary"
                                        className={classes.body1}>
                                        {tn.lang.repeatSubtitle(agreement.repeat)}
                                    </Typography>
                                </div>
                                <div className={classes.splitAgreement}>
                                    {this.renderAgreementSplit(((agreement.pendingChange
                                        && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE)
                                        ? agreement.pendingChange.split
                                        : agreement.split), false, agreement.amount)}
                                </div>
                            </div>
                            <div style={{flexDirection: 'row', display: 'flex', justifyContent: 'flex-end'}}>
                                {(agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE
                                    && ((agreement.pendingChange.split.find((s) => s.accountId === this.props.userId)?.percentage) !==
                                        (agreement.split.find((s) => s.accountId === this.props.userId)?.percentage)))
                                    ? <div
                                        className={classes.splitAgreement}>{this.renderAgreementSplit(agreement.split, true, agreement.amount)}</div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                    {((!!agreement.description && agreement.description.length > 0)
                            || (agreement.images && agreement.images.length > 0)) &&
                        (<div className={classes.itemMiddleRow}>
                            {(!!agreement.description && agreement.description.length > 0) &&
                                <div className={classes.descriptionWrapper}>
                                    <Typography className={classes.body3} paragraph={false}>
                                        {agreement.description}
                                    </Typography>
                                </div>}

                            {agreement.images && agreement.images.length > 0 && (
                                <div className={classes.galleryList}>
                                    {agreement.images.map((img,index) => (
                                        <div className={classes.galleryListItem} key={index} onClick={() => this.setState({zoomImage:img})}>
                                            <img src={img.url} alt={img.fileName}/>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>)
                    }

                </CardContent>
                <div className={classes.cardActions}>
                    {type === 'sent' && (
                        <>
                            <div className={classes.leftActions}>
                                <ChatButton 
                                    chatId={agreement.chatId}
                                    family={this.props.family}
                                    referenceObject={agreement.id}
                                    chatType={ChatType.AGREEMENT_CHAT}
                                    waitForAgreementChat={this.props.waitForAgreementChat}
                                    title={tn.lang.agreementRegardingTitle(agreement.title)}
                                    msg={tn.lang.agreementRegardingTitle(agreement.title)}/>
                                <Button  onClick={() => {
                                            if (agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE) {
                                                this.props.respondChange({
                                                    agreementId: agreement.id,
                                                    changeId:agreement.pendingChange.id,
                                                    approved: false});

                                            } else {
                                                this.props.respond({
                                                    agreementId: agreement.id,
                                                    approved: false});
                                            }
                                        }}>{tn.lang.remove}</Button>
                                <Button color='default' variant='outlined'
                                 onClick={() => this.props.edit()}>{tn.lang.update}
                                 </Button>
                            </div>

                        </>
                    )}
                    {type === 'received' && (
                        <>
                            <ChatButton 
                                chatId={agreement.chatId}
                                family={this.props.family}
                                referenceObject={agreement.id}
                                chatType={ChatType.AGREEMENT_CHAT}
                                waitForAgreementChat={this.props.waitForAgreementChat}
                                title={tn.lang.agreementRegardingTitle(agreement.title)}
                                msg={tn.lang.agreementRegardingTitle(agreement.title)}/>
                            <Button variant='text' onClick={() => this.props.edit()}>{tn.lang.update}</Button>
                            <Button color='secondary' variant='outlined'
                                    onClick={() => {
                                        if (agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE) {
                                            this.props.respondChange({
                                                agreementId: agreement.id,
                                                changeId:agreement.pendingChange.id,
                                                approved: false});

                                        } else {
                                            this.props.respond({
                                                agreementId: agreement.id,
                                                approved: false});
                                        }
                                    }}>{tn.lang.deny}
                            </Button>
                            <Button color='primary' variant='contained'
                                    onClick={() => 
                                        {
                                            if (agreement.pendingChange && agreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE) {
                                                this.props.respondChange({
                                                    agreementId: agreement.id,
                                                    changeId:agreement.pendingChange.id,
                                                    approved: true});

                                            } else {
                                                this.props.respond({
                                                    agreementId: agreement.id,
                                                    approved: true});
                                            }
                                        }
                                    }>{tn.lang.agree}
                            </Button>
                        </>
                    )}
                </div>
                {type === 'sent' && (<div className={classes.rightActions} style={{marginTop:'5px'}}>
                        {agreement.seenBy.length > 0 && (
                            <>
                                <Typography style={{paddingRight:'4px'}} className={classes.body1}>{tn.lang.agreementSeenBy}</Typography>
                                {agreement.seenBy.map(
                                    (userId) => {
                                        const account = this.props.family.find((member) => member.id === userId);
                                        if (!account) return null;
                                        return this.getAvatar(account, 14);
                                    }
                                )}
                            </>
                        )}
                    </div>)}
            </div>
            <Dialog
                open={(this.state.zoomImage !== undefined)}
                onClose={() => {this.setState({zoomImage:undefined});}}
                fullWidth={true}
            >
                <DialogTop >
                <Col style={{flex:1, alignItems: 'center'}}>
                    <DialogTitle>{fileTitle}</DialogTitle>
                </Col>
                <IconButton onClick={() => {this.setState({zoomImage:undefined});}}>
                    <CloseIcon />
                </IconButton>
                </DialogTop>
                <CustomDialogContent style={{position:'relative', padding:0}}>
                <img src={fileUrl} alt={fileTitle} style={{height:'auto'}}/>
                </CustomDialogContent>
                <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
                <Button onClick={() => {this.setState({zoomImage:undefined});}} color='default' variant='contained' size="large">
                    {tn.lang.done}
                </Button>
                </Row>
            </Dialog>
          </>
        );
    }
    private getAvatar(member: IFamilyMember, size: number = 30, grayed: boolean = false, marginLeft: number = 0) {
        const image = member.avatar;
        const name = member.firstName;
        const color = member.color;
        const style: any = {width: size, height: size, marginLeft};

        return <ImgAvatar key={member.id} color={color} imgName={image} style={style} altText={name} grayed={grayed}
            imgUrl={member.imageAvatar?member.avatarURL:undefined} />;
    }


    private isInViewport(offset = 0) {
        if (!this.myRef) { return false; }
        const rect = this.myRef.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
    
        if (!(rect.left >= 0 && rect.right <= viewWidth)) { return false; }
        if (!(rect.top >= 0 && (rect.top + 50) <= viewHeight)) { return false; } // if 50 pixels has been seen thats enough
    
        return true;
    }

    private renderAgreementSplit = (splitAgreement: IEcoSplit[], isOldValue: boolean = false, cost:number|undefined) => {
        const {classes} = this.props;
        const fullResponsibility = splitAgreement.find(sa => sa.percentage === 100);

        if (fullResponsibility) {
            const account = this.props.family.find((member) => member.id === fullResponsibility.accountId);
            if (!account) return;
            return (
                <Grid key={account.id}
                      className={isOldValue ? classes.splitAgreementItemLineThrough : classes.splitAgreementItem}>
                    <Typography className={classes.body2}
                                style={isOldValue ? {textDecorationLine: 'line-through'} : {}}>
                        <span>{tn.lang.agreementPaysAll(account.firstName)}</span>
                    </Typography>
                </Grid>
            );
        }
        const myShare = splitAgreement.find(sa => sa.accountId === this.props.userId);
        if (myShare) {
            return (
                <Grid key={this.props.userId} className={classes.splitAgreementItem} style={{}}>
                    <Typography color="textSecondary" className={classes.body2}
                                style={isOldValue ? {textDecorationLine: 'line-through'} : {}}>
                        <span>{
                            tn.lang.agreementMyPart(myShare.percentage)
                            +((cost && cost > 0 && !isOldValue)
                                ?(" = "+tn.formatNumber(Math.floor((cost*myShare.percentage)/100), this.props.currency))
                                :"")}
                        </span>
                    </Typography>
                </Grid>
            );
        }
        return splitAgreement.map(
            (split) => {
                const account = this.props.family.find((member) => member.id === split.accountId);
                if (!account) return null;
                return (
                    <Grid key={account.id}
                          className={isOldValue ? classes.splitAgreementItemLineThrough : classes.splitAgreementItem}>
                        {isOldValue && (<div className={classes.absoluteLineThrough}/>)}
                        {this.getAvatar(account, 14, isOldValue)}
                        <Typography className={classes.body2}>
                            {split.percentage}%
                        </Typography>
                    </Grid>
                );
            }
        );
    }
}

export default withStyles(styles)(AgreementCard);



// WEBPACK FOOTER //
// ./src/components/economy/AgreementCard.tsx